import { Injectable, signal, TemplateRef } from '@angular/core';

export interface Toast {
  template: TemplateRef<any>;
  classname?: string;
  delay?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toasts = signal<Toast[]>([]);
  readonly toasts = this._toasts.asReadonly();

  newToastAdd?: () => void;

  show(toast: Toast) {
    this._toasts.update((toasts) => [...toasts, toast]);
    if (this.newToastAdd) {
      this.newToastAdd();
    }
  }

  remove(toast: Toast) {
    this._toasts.update((toasts) => toasts.filter((t) => t !== toast));
    if (this.newToastAdd) {
      this.newToastAdd();
    }
  }

  clear() {
    this._toasts.set([]);
    if (this.newToastAdd) {
      this.newToastAdd();
    }
  }
}
